import React, { useEffect, useRef, useState } from "react"
import AddClient from "./Modals/AddClient"
import { useDispatch, useSelector } from "react-redux"
import {
  getAbonementsClient,
  getAbonementsList,
  getClientTrainings,
  getClientsList,
  setAddClientModal,
  getPacketsList,
} from "src/store/Slices/ClientsSlice"
import { Input, Space, Button, Select, DatePicker } from "antd"
import { formateDate } from "src/components/helpers/formateDate"
import UserModal from "./Modals/UserModal"
import { SearchOutlined } from "@ant-design/icons"
import {
  CButton,
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CNavLink,
  CTooltip,
} from "@coreui/react"
import SecondTable from "./Tables/SecondTable"
import CIcon from "@coreui/icons-react"
import { cilPen } from "@coreui/icons"
import AntdTable from "src/components/AntdTable/Table"
import MobileClientsPage from "./Mobile/MobileClientsPage"
import dayjs from "dayjs"
import { refreshAuthToken } from "src/store/Slices/AuthSlice"
const { RangePicker } = DatePicker
const Clients = () => {
  // HELPERS
  const dispatch = useDispatch()

  // STORE
  const clientsList = useSelector((state) => state.ClientsSlice.clientsList)
  const clientsListLoading = useSelector(
    (state) => state.ClientsSlice.clientsListLoading
  )
  const addClientModal = useSelector(
    (state) => state.ClientsSlice.addClientModal
  )
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList
  )
  const getAbonementsClientList = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientList
  )
  const getAbonementsClientListLoading = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientListLoading
  )
  const getClientTrainingsList = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsList
  )
  const getClientTrainingsListLoading = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsListLoading
  )

  // STATE
  const [clientInfo, setClientInfo] = useState({})
  const [clientModal, setClientModal] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [dataIndex, setDataIndex] = useState("")
  const [selectedKeys, setSelectedKyes] = useState("")
  const [isDeleted, setIsDeleted] = useState(false)
  const [isActive, setIsActive] = useState(true)
  const [isDeletedTrain, setIsDeletedTrain] = useState(false)
  const [isActiveTrain, setIsActiveTrain] = useState(true)
  const [tableHeight, setTableHeight] = useState(600)
  const [showSecondTable, setShowSecondTable] = useState(false)
  const [sortByBirthday, setSortByBirthday] = useState([])
  const [sortByIdFrom, setSortIdFrom] = useState()
  const [sortByIdTo, setSortIdTo] = useState()

  // REF
  const searchInput = useRef(null)

  // FUNCTIONS
  const handleReset = (clearFilters) => {
    dispatch(getClientsList({ count: pageSize, offset: pageSize * (page - 1) }))
    setSortByBirthday()
    clearFilters()
    setPage()
    setPageSize()
    setDataIndex()
    setSelectedKyes()
    setIsDeleted()
    setIsActive()
    setIsDeletedTrain()
    setIsActiveTrain()
    setSortByBirthday()
    setSortIdFrom()
    setSortIdTo()
  }

  const title = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <CNav variant='tabs'>
            <CNavItem>
              <CNavLink style={{ cursor: "pointer" }} active={true}>
                Клиенты
              </CNavLink>
            </CNavItem>
          </CNav>
          <div style={{ display: "flex", alignItems: "center" }}>
            <CButton
              size='sm'
              onClick={() => {
                dispatch(setAddClientModal(true))
              }}
              style={{ color: "#fff" }}
            >
              Добавить
            </CButton>
          </div>
        </div>
      </>
    )
  }

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div>
          {title !== "Дата рождения" && title !== "№" && title !== "Статус" && (
            <Input
              ref={searchInput}
              placeholder={`Искать ${title}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
          )}
          {title === "Статус" && (
            <Select
              onClick={() => {
                {
                  dispatch(
                    passagesAction({
                      flag: "get",
                      value: { Status: selectedKeys },
                    })
                  )
                }
              }}
              style={{ width: "100%", marginBottom: "8px" }}
              options={success}
              onChange={(e) => {
                setSelectedKeys([e])
              }}
              value={selectedKeys[0]}
              placeholder='Выбрать'
            />
          )}
          {title === "№" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByIdFrom}
                onChange={(e) => setSortIdFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByIdTo}
                onChange={(e) => setSortIdTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Дата рождения" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByBirthday}
                onChange={setSortByBirthday}
                format='DD.MM.YYYY'
              />
            </div>
          )}
        </div>
        <Space>
          <Button
            type='primary'
            onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Искать
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleReset(clearFilters)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text,
  })

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    setSelectedKyes(selectedKeys[0])
    setDataIndex(dataIndex)
    dispatch(
      getClientsList({
        [`${dataIndex}`]: selectedKeys[0],
        birthdayFrom:
          sortByBirthday &&
          dayjs(sortByBirthday[0], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
        birthdayTo:
          sortByBirthday &&
          dayjs(sortByBirthday[1], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
      })
    )
  }

  const columns = clientsList?.data?.value?.columns?.map((element, index) => {
    return {
      key: element.field,
      title: element.title,
      dataIndex: element.dataIndex,
      ellipsis: {
        showTitle: false,
      },
      width: element.width,
      ...getColumnSearchProps(element.dataIndex, element.title),
      sorter: true,
    }
  })

  const rows = clientsList?.data?.value?.rows.map((element) => {
    return {
      key: element?.id,
      id: element.id,
      phoneNumber: element.phoneNumber,
      eMail: element.eMail,
      clientF: element.clientF,
      clientI: element.clientI,
      clientO: element.clientO,
      birthday: element.birthday ? formateDate(element.birthday) : "",
      abonementFrom: element.abonementFrom
        ? formateDate(element.abonementFrom)
        : "",
      abonementTo: element.abonementTo ? formateDate(element.abonementTo) : "",
      frozenTo: element.frozenTo ? formateDate(element.frozenTo) : "",
      abonement: element.abonement,
      club: element.club,
    }
  })

  const onClickRowOne = (record) => {
    setClientInfo(record)
    dispatch(
      getAbonementsClient({
        clientId: record.id,
        isDeleted: isDeleted,
        isActive: isActive,
      })
    )
    dispatch(getClientTrainings({ clientId: record.id }))
    setTableHeight(250)
    setShowSecondTable(true)
  }

  const rowClassName = (record) => {
    return record?.key === clientInfo?.key ? "selected-row" : ""
  }

  const handleTableChange = (pagination, filters, sorter) => {
    dispatch(
      getClientsList({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        [`${dataIndex}`]: dataIndex ? selectedKeys : undefined,
        birthdayFrom:
          sortByBirthday &&
          dayjs(sortByBirthday[0], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
        birthdayTo:
          sortByBirthday &&
          dayjs(sortByBirthday[1], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    dispatch(getAbonementsList())
    dispatch(getClientsList())
  }, [])

  return (
    <>
      <AddClient visibleAddClient={addClientModal} />
      <UserModal
        clientModal={clientModal}
        setClientModal={setClientModal}
        clientInfo={clientInfo}
      />
      {window.innerWidth >= 768 ? (
        <div style={{ overflow: "auto" }}>
          <AntdTable
            pageSize={pageSize}
            setPageSize={setPageSize}
            page={page}
            setPage={setPage}
            loading={clientsListLoading}
            columns={
              columns && [
                ...columns,
                {
                  title: "Действия",
                  key: "action",
                  align: "center",
                  render: (_, record) => (
                    <a
                      className='text-primary text-decoration-none'
                      onClick={() => {
                        setClientInfo(record)
                        setClientModal(true)
                      }}
                    >
                      Изменить
                    </a>
                  ),
                  width: 80,
                },
              ]
            }
            rows={rows}
            scroll={{ x: 0, y: tableHeight }}
            title={title}
            onClickRowOne={onClickRowOne}
            total={clientsList?.data?.value?.totalCount}
            onChange={handleTableChange}
            rowClassName={rowClassName}
          />
          {showSecondTable && (
            <SecondTable
              abonementRows={getAbonementsClientList?.data?.value?.rows}
              abonementColumns={getAbonementsClientList?.data?.value?.columns}
              abonementTotalCount={
                getAbonementsClientList?.data?.value?.totalCount
              }
              abonementLoading={getAbonementsClientListLoading}
              clientInfo={clientInfo}
              trainingRows={getClientTrainingsList?.data?.value?.rows}
              trainingColumns={getClientTrainingsList?.data?.value?.columns}
              trainingLoading={getClientTrainingsListLoading}
              isDeleted={isDeleted}
              setIsDeleted={setIsDeleted}
              isActive={isActive}
              setIsActive={setIsActive}
              isDeletedTrain={isDeletedTrain}
              setIsDeletedTrain={setIsDeletedTrain}
              isActiveTrain={isActiveTrain}
              setIsActiveTrain={setIsActiveTrain}
            />
          )}
          ,
        </div>
      ) : (
        <MobileClientsPage
          clients={clientsList?.data?.value}
          clientsLoading={clientsListLoading}
          abonements={getAbonementsClientList?.data?.value}
          abonementsLoading={getAbonementsClientListLoading}
          getClientTrainingsList={getClientTrainingsList?.data?.value}
        />
      )}
    </>
  )
}

export default Clients
